// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"30":"61748222","513":"6c9482d3"}[chunkId] + ".css";
};